export const CONTENT_ACTION_IDS = {
  CLONE: 'clone',
  DETAILS: 'details',
  VIEW: 'view',
  ARCHIVE: 'archive',
  UNARCHIVE: 'unarchive',
  ADD_TO_LANGUAGE_GROUP: 'addToLanguageGroup',
  CREATE_LANGUAGE_VARIANT: 'createLanguageVariant',
  CONVERT_TO_LANGUAGE_GROUP_PRIMARY: 'convertToLanguageGroupPrimary',
  DELETE_LANGUAGE_GROUP: 'deleteLanguageGroup',
  REMOVE_FROM_LANGUAGE_GROUP: 'removeFromLanguageGroup',
  PUBLISHING_OPTIONS: 'publishingOptions',
  UNPUBLISHING_OPTIONS: 'unpublishingOptions',
  RUN_A_TEST: 'runATest',
  EDIT: 'edit',
  DELETE: 'delete',
  ASSIGN_PERMISSIONS: 'assignPermissions',
  CONTROL_AUDIENCE_ACCESS: 'controlAudienceAccess',
  SWITCH_LANGUAGE_GROUP_PRIMARY: 'switchLanguageGroupPrimary',
  PROMOTE_SOCIAL_POST: 'promoteSocialPost',
  PROMOTE_AD_CAMPAIGN: 'promoteAdCampaign',
  EDIT_CAMPAIGN: 'editCampaign',
  UPDATE_DOMAIN_LANGUAGE: 'updateDomainLanguage'
};